import '@/assets/styles/app.scss'
import Vue from 'vue'
import App from './App'
import router from '@/router'
import store from '@/store'
import '@/plugins'
import '@/components'
import '@/filters'

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    store,
    ...App,
    template: '<App/>'
})

/**
 * Chat.hu initialized ...
 *
 * Listázok todo:
 *  + Táblázat lapozható legyen
 *  + Search bekötése ( URL-ben urlencodera figyelj, gépelésre, legyen egy debounce )
 *  + Order szerint is lehessen rendezni
 *  + Többi ( Stagin és Archived bekötése )
 *  + Kiválasztás bekötése
 *  + Pénzformázó filter írása
 *  + Offer wrapper gombok átrakása a listázóban
 *  + Valami loading animáció amíg tölt
 *  + Ha nincs offer akkor legyen üzenet hogy "Sorry"
 *  + routes authGuardba minde route
 *  + Takarítás, amik most nem lesznek kerüljenek ki:
 *     + Táblázatból a "felesleges oszlopok"
 *     + Menüből minden ami most nem lesz
 *  + Edit offer fülek pipa - expires at nem kötelező és host n post disable akkor kell referral
 *  + is_valid beállítása
 *  + Stagingben pipa kör is_valid kb
 *  + new tab implement
 *  + pause play -> is_active a livenal
 *  + tracking codes
 *  + A táblázatban betöltés közben néha látszik a "No offers" ( hagyjuk, enyhítettem, de még mindig "néha" előjön)
 *  + A táblázat sora felett az egér legyen "mozgatható" ( a minden irányú nyilacska )
 *  + Ha nem uploadolta a képet és elváltana az oldalról akkor jöjjön fel egy " You have unsaved changed, do you want to continue ? " és ha No-t nyom maradjon
 *  + Ha nem is_valid ne lehessen publisholni (hagyd, Megoldva backenden)
 *  + Ha váltasz a tabok között a sort és page-eket resetelje ( Live 2-es oldalról ha Staging-re ugrasz és nincs 2-es oldal már buktad :D )
 *  + A táblázat play -re is jöjjön fel a csoda modal meg amikor az archived-be a nyilacskára akkor is
 *  + A dátumok mikor lesz az offer active kamuk a publish modálon :)
 *  - Táblázatban a status ikon a jelenlegi statuszt mutatja és ha hoverezik akkor mutatja a másikat
 *  - Ha töröl valamit a formon akkor a pipa nem deaktiválódik
 *

*/



// WEBPACK FOOTER //
// ./src/main.js